import { getAlarmStatus } from './pageHome';
/* eslint-disable no-plusplus */
function generateTimestamp(index) {
  const now = new Date();
  const twelveHoursAgo = new Date(now.getTime() - (index * 60000));
  return twelveHoursAgo.toISOString();
}

function generateVitalSigns({
  min, max, bed, vitalSign,
}) {
  const activeToggle = !bed ? true : bed % 2 === 1;

  // eslint-disable-next-line no-unused-vars
  const vitalSigns = Array.from({ length: 30 }, (_, i) => {
    const value = Math.floor(Math.random() * (max - min + 1)) + min;

    return ({
      timeStamp: generateTimestamp(i),
      alarmStatus: getAlarmStatus(value, vitalSign),
      isTemperatureEnabled: activeToggle,
      isCarbonDioxideEnabled: activeToggle,
      value,
    });
  });
  return vitalSigns.reverse();
}

export const monitor = {
  GetMonitorDashboard: (ref) => {
    if (!ref || !ref.bed) return undefined;
    const { bed } = ref;
    const bedNum = Number(bed.split('#')[2]);
    const activeToggle = bedNum % 2 === 1;
    return (
      {
        getMonitorDashboard: {
          isTemperatureEnabled: activeToggle,
          isCarbonDioxideEnabled: activeToggle,
          vitalSigns: [
            {
              name: 'temperature',
              value: generateVitalSigns({
                min: 36, max: 40, bed: bedNum, vitalSign: 'temperature',
              }),
            },
            {
              name: 'heartRate',
              value: generateVitalSigns({
                min: 40, max: 180, bed: null, vitalSign: 'heartRate',
              }),
            },
            {
              name: 'respiratoryRate',
              value: generateVitalSigns({
                min: 8, max: 40, bed: null, vitalSign: 'respiratoryRate',
              }),
            },
            {
              name: 'oxygenSaturation',
              value: generateVitalSigns({
                min: 70, max: 100, bed: null, vitalSign: 'oxygenSaturation',
              }),
            },
            {
              name: 'systolicArterialPressure',
              value: generateVitalSigns({
                min: 70, max: 200, bed: null, vitalSign: 'systolicArterialPressure',
              }),
            },
            {
              name: 'diastolicArterialPressure',
              value: generateVitalSigns({
                min: 40, max: 120, bed: null, vitalSign: 'diastolicArterialPressure',
              }),
            },
            {
              name: 'meanArterialPressure',
              value: generateVitalSigns({
                min: 50, max: 140, bed: null, vitalSign: 'meanArterialPressure',
              }),
            },
            {
              name: 'carbonDioxide',
              value: generateVitalSigns({
                min: 30, max: 45, bed: bedNum, vitalSign: 'carbonDioxide',
              }),
            },
          ],
        },
      }
    );
  },
  SaveBedPreferences: (onCompleted) => [() => onCompleted(), { loading: false }],
};
